var _defs, _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeafnoteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b8bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ad29f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 18,
    fill: "url(#g1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 18)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 6c-10 2-24 10-30 20 6 12 18 20 30 24 8-4 16-10 20-20-8-10-18-18-20-24z",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 44c-8 6-20 10-32 8 8 6 20 8 32 6 6-2 12-6 16-10-6 0-12-4-16-4z",
    opacity: 0.9
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 106,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fill: "#0f1724",
    textAnchor: "middle"
  }, "Leafnote")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafnoteLogo);
export default __webpack_public_path__ + "static/media/leafnote-logo.e952db649d2dc74a776ca4c52b4ecc0d.svg";
export { ForwardRef as ReactComponent };